export const get_notifications = state => state.notifications || [];
